// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as DrawerState$Showside from "../context/DrawerState.bs.js";
import * as HideOnScroll$Showside from "../utils/HideOnScroll.bs.js";
import * as MobileNavbar$Showside from "./MobileNavbar.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function ListPageMobileNavbar(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var topLevelCategories = Props.topLevelCategories;
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var drawerState = DrawerState$Showside.Provider.use(undefined);
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: match.isMobile && drawerState === /* Open */2,
    children: React.createElement(HideOnScroll$Showside.make, {
      scrollableRef: scrollableContainerRef,
      children: React.createElement(MobileNavbar$Showside.make, {
        position: match$1.embedType === /* Inline */1 ? /* Sticky */0 : /* Fixed */1,
        topLevelCategories: topLevelCategories,
        showFilters: true,
        showBackToTopButton: true,
        initiator: "plp-navbar",
        scrollableContainerRef: scrollableContainerRef
      })
    })
  });
}
ListPageMobileNavbar.displayName = "ListPageMobileNavbar";
var make = ListPageMobileNavbar;
export { make };
/* react Not a pure module */